// Import HTTP client
import {
  getSwapPairsAssetsDetailsService,
  createBeneficiaryService,
  getSavedBeneficiariesService,
  initiateSwapService,
  deleteBeneficiaryService,
  getSwappedPairDetailsByIdService,
  getSwappedTransactionsService,
  processSwapApprovalService
} from '@/services/bridgeService.js'

/** mutation types */
const set_currentSwapBeneficiaryDetails = 'set_currentSwapBeneficiaryDetails'
const set_currentConfirmationScreenStep = 'set_currentConfirmationScreenStep'
const set_fromSwapAssetDetails = 'set_fromSwapAssetDetails'
const set_toSwapAssetDetails = 'set_toSwapAssetDetails'
const set_swapTransactionStatus = 'set_swapTransactionStatus'
const set_swapPairsAssetsDetails = 'set_swapPairsAssetsDetails'
const set_savedBeneficiaries = 'set_savedBeneficiaries'
const set_swapFormDetails = 'set_swapFormDetails'
const set_initiatedSwapDetails = 'set_initiatedSwapDetails'
const set_swappedPairDetailsById = 'set_swappedPairDetailsById'
const set_pendingSwappedTransactions = 'set_pendingSwappedTransactions'
const set_processingSwappedTransactions = 'set_processingSwappedTransactions'
const set_completedSwappedTransactions = 'set_completedSwappedTransactions'
const set_awaitingSwappedTransactions = 'set_awaitingSwappedTransactions'
const set_beneficiaryDetailsForm = 'set_beneficiaryDetailsForm'
const set_filterInfo = 'set_filterInfo'
const set_filterUse = 'set_filterUse'
/** state */
const getDefaultState = () => {
  return {
    currentSwapBeneficiaryDetails: null,
    currentConfirmationScreenStep: 0,
    fromSwapAssetDetails: null,
    toSwapAssetDetails: null,
    swapTransactionStatus: 'awaitingDeposit',
    swapPairsAssetsDetails: null,
    savedBeneficiaries: null,
    swapFormDetails: null,
    initiatedSwapDetails: null,
    swappedPairDetailsById: null,
    pendingSwappedTransactions: null,
    processingSwappedTransactions: null,
    awaitingSwappedTransactions: null,
    completedSwappedTransactions: null,
    beneficiaryDetailsForm: null,
    filterInfo: {},
    filterUse: false
  }
}
const state = getDefaultState()
/** getters */
const getters = {
  currentSwapBeneficiaryDetails: () => state.currentSwapBeneficiaryDetails
}
/** mutations */
const mutations = {
  [set_currentSwapBeneficiaryDetails] (state, data) {
    state.currentSwapBeneficiaryDetails = data
  },
  [set_beneficiaryDetailsForm] (state, data) {
    state.beneficiaryDetailsForm = data
  },
  [set_currentConfirmationScreenStep] (state, data) {
    state.currentConfirmationScreenStep = data
  },
  [set_fromSwapAssetDetails] (state, data) {
    state.fromSwapAssetDetails = data
  },
  [set_toSwapAssetDetails] (state, data) {
    state.toSwapAssetDetails = data
  },
  [set_swapPairsAssetsDetails] (state, data) {
    state.swapPairsAssetsDetails = data
  },
  [set_swapTransactionStatus] (state, data) {
    state.swapTransactionStatus = data
  },
  [set_savedBeneficiaries] (state, data) {
    state.savedBeneficiaries = data
  },
  [set_swapFormDetails] (state, data) {
    state.swapFormDetails = data
  },
  [set_initiatedSwapDetails] (state, data) {
    state.initiatedSwapDetails = data
  },
  [set_swappedPairDetailsById] (state, data) {
    state.swappedPairDetailsById = data
  },
  [set_pendingSwappedTransactions] (state, data) {
    state.pendingSwappedTransactions = data
  },
  [set_processingSwappedTransactions] (state, data) {
    state.processingSwappedTransactions = data
  },
  [set_awaitingSwappedTransactions] (state, data) {
    state.awaitingSwappedTransactions = data
  },
  [set_completedSwappedTransactions] (state, data) {
    state.completedSwappedTransactions = data
  },
  [set_filterInfo] (state, data) {
    state.filterInfo = data
  },
  [set_filterUse] (state, data) {
    state.filterUse = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}
/** actions */
const actions = {
  resetBridgeState ({ commit }) {
    commit('resetState')
  },
  setCurrentSwapBeneficiaryDetails: ({ commit }, payload) => {
    commit('set_currentSwapBeneficiaryDetails', payload)
  },
  setBeneficiaryDetailsForm: ({ commit }, payload) => {
    commit('set_beneficiaryDetailsForm', payload)
  },
  setCurrentConfirmationScreenStep: ({ commit }, payload) => {
    commit('set_currentConfirmationScreenStep', payload)
  },
  setfromSwapAssetDetails: ({ commit }, payload) => {
    commit('set_fromSwapAssetDetails', payload)
  },
  settoSwapAssetDetails: ({ commit }, payload) => {
    commit('set_toSwapAssetDetails', payload)
  },
  setSwapTransactionStatus: ({ commit }, payload) => {
    commit('set_swapTransactionStatus', payload)
  },
  getSwapPairsAssetsDetails: ({ commit }, payload) => {
    return getSwapPairsAssetsDetailsService(payload).then((response) => {
      commit('set_swapPairsAssetsDetails', response.data.data)
    })
  },
  createBeneficiary: ({ commit }, payload) => {
    return createBeneficiaryService(payload)
  },
  processSwapApproval: ({ commit }, payload) => {
    return processSwapApprovalService(payload)
  },
  getSavedBeneficiaries: ({ commit }, payload) => {
    return getSavedBeneficiariesService(payload).then((response) => {
      commit('set_savedBeneficiaries', response.data.data)
    })
  },
  setSwapFormDetails: ({ commit }, payload) => {
    commit('set_swapFormDetails', payload)
  },
  initiateSwap: ({ commit }, payload) => {
    return initiateSwapService(payload).then((response) => {
      commit('set_initiatedSwapDetails', response.data.data)
    })
  },
  getSwappedPairDetailsById: ({ commit }, payload) => {
    return getSwappedPairDetailsByIdService(payload).then((response) => {
      commit('set_swappedPairDetailsById', response.data.data)
    })
  },
  getSwappedTransactions: ({ commit }, payload) => {
    const transactionType =
      payload.status === 'pending'
        ? 'pending'
        : payload.status === 'processing'
        ? 'processing'
        : payload.status === 'awaiting_business_approval'
        ? 'awaiting'
        : 'completed'
    const transactionMutation = `set_${transactionType}SwappedTransactions`
    return getSwappedTransactionsService(payload).then((response) => {
      commit(transactionMutation, response.data.data)
    })
  },
  clearMainSwapState: ({ commit }) => {
    commit('set_swapFormDetails', null)
    commit('set_toSwapAssetDetails', null)
    commit('set_fromSwapAssetDetails', null)
    commit('set_currentSwapBeneficiaryDetails', null)
    commit('set_currentConfirmationScreenStep', 0)
  },
  deleteBeneficiary: ({ commit }, payload) => {
    return deleteBeneficiaryService(payload)
  },
  setFilterInfo: ({ commit }, payload) => {
    commit('set_filterInfo', payload)
  },
  setFilterUse: ({ commit }, payload) => {
    commit('set_filterUse', payload)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
